import { useMemo } from 'react';
import { LXModuleParams } from '../../../util/lx';

interface Args {
  cardName?: string;
  cardLink?: string;
}

const useWinCardParams: (bid: string, args: Args) => LXModuleParams = (bid, { cardName, cardLink }) => {
  const moduleParams = useMemo(() => {
    return {
      bid,
      custom: {
        cardName,
        cardLink,
      },
    };
  }, [bid, cardName, cardLink]);
  return moduleParams;
};

export const useWinCardClickParams: (args: Args) => LXModuleParams = (args) => {
  return useWinCardParams('b_donation_8o2bl9vq_mc', args);
};
